// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/membership/v1/vision_membership.proto (package protos.vision.membership.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/membership/v1/vision_membership.proto.
 */
export const file_vision_membership_v1_vision_membership: GenFile = /*@__PURE__*/
  fileDesc("Cix2aXNpb24vbWVtYmVyc2hpcC92MS92aXNpb25fbWVtYmVyc2hpcC5wcm90bxIbcHJvdG9zLnZpc2lvbi5tZW1iZXJzaGlwLnYxItQBChZWaXNpb25JbnZpdGVQdWJsaWNWaWV3EhQKDHByb2plY3RfbmFtZRgBIAEoCRIXCg9pbnZpdGVkX2J5X25hbWUYAiABKAkSDQoFZW1haWwYAyABKAkSOwoEcm9sZRgEIAEoDjItLnByb3Rvcy52aXNpb24ubWVtYmVyc2hpcC52MS5WaXNpb25NZW1iZXJSb2xlEj8KBnN0YXR1cxgFIAEoDjIvLnByb3Rvcy52aXNpb24ubWVtYmVyc2hpcC52MS5WaXNpb25JbnZpdGVTdGF0dXMiugEKEFZpc2lvbkludml0ZVZpZXcSEQoJaW52aXRlX2lkGAEgASgJEg0KBWVtYWlsGAIgASgJEjsKBHJvbGUYAyABKA4yLS5wcm90b3MudmlzaW9uLm1lbWJlcnNoaXAudjEuVmlzaW9uTWVtYmVyUm9sZRIXCg9pbnZpdGVkX2J5X25hbWUYBCABKAkSLgoKY3JlYXRlZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAi0gEKEFZpc2lvbk1lbWJlclZpZXcSEgoKYWNjb3VudF9pZBgBIAEoCRIMCgRuYW1lGAIgASgJEg8KB3BmcF91cmwYAyABKAkSOwoEcm9sZRgEIAEoDjItLnByb3Rvcy52aXNpb24ubWVtYmVyc2hpcC52MS5WaXNpb25NZW1iZXJSb2xlEhAKCGlzX293bmVyGAUgASgIEi0KCWpvaW5lZF9hdBgGIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASDQoFaXNfbWUYByABKAgqlQEKEFZpc2lvbk1lbWJlclJvbGUSHgoaVklTSU9OX01FTUJFUl9ST0xFX1VOS05PV04QABIgChxWSVNJT05fTUVNQkVSX1JPTEVfVklFV19PTkxZEAESGwoXVklTSU9OX01FTUJFUl9ST0xFX0VESVQQAhIiCh5WSVNJT05fTUVNQkVSX1JPTEVfRlVMTF9BQ0NFU1MQAyrnAQoSVmlzaW9uSW52aXRlU3RhdHVzEiAKHFZJU0lPTl9JTlZJVEVfU1RBVFVTX1VOS05PV04QABIgChxWSVNJT05fSU5WSVRFX1NUQVRVU19QRU5ESU5HEAESIAocVklTSU9OX0lOVklURV9TVEFUVVNfU0VORElORxAFIgQIAhACIgQIAxADIgQIBBAEKh1WSVNJT05fSU5WSVRFX1NUQVRVU19BQ0NFUFRFRCocVklTSU9OX0lOVklURV9TVEFUVVNfUkVWT0tFRCocVklTSU9OX0lOVklURV9TVEFUVVNfRVhQSVJFRGIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * @generated from message protos.vision.membership.v1.VisionInvitePublicView
 */
export type VisionInvitePublicView = Message<"protos.vision.membership.v1.VisionInvitePublicView"> & {
  /**
   * @generated from field: string project_name = 1;
   */
  projectName: string;

  /**
   * @generated from field: string invited_by_name = 2;
   */
  invitedByName: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: protos.vision.membership.v1.VisionMemberRole role = 4;
   */
  role: VisionMemberRole;

  /**
   * @generated from field: protos.vision.membership.v1.VisionInviteStatus status = 5;
   */
  status: VisionInviteStatus;
};

/**
 * Describes the message protos.vision.membership.v1.VisionInvitePublicView.
 * Use `create(VisionInvitePublicViewSchema)` to create a new message.
 */
export const VisionInvitePublicViewSchema: GenMessage<VisionInvitePublicView> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_vision_membership, 0);

/**
 * @generated from message protos.vision.membership.v1.VisionInviteView
 */
export type VisionInviteView = Message<"protos.vision.membership.v1.VisionInviteView"> & {
  /**
   * @generated from field: string invite_id = 1;
   */
  inviteId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: protos.vision.membership.v1.VisionMemberRole role = 3;
   */
  role: VisionMemberRole;

  /**
   * @generated from field: string invited_by_name = 4;
   */
  invitedByName: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.VisionInviteView.
 * Use `create(VisionInviteViewSchema)` to create a new message.
 */
export const VisionInviteViewSchema: GenMessage<VisionInviteView> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_vision_membership, 1);

/**
 * @generated from message protos.vision.membership.v1.VisionMemberView
 */
export type VisionMemberView = Message<"protos.vision.membership.v1.VisionMemberView"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string pfp_url = 3;
   */
  pfpUrl: string;

  /**
   * @generated from field: protos.vision.membership.v1.VisionMemberRole role = 4;
   */
  role: VisionMemberRole;

  /**
   * @generated from field: bool is_owner = 5;
   */
  isOwner: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp joined_at = 6;
   */
  joinedAt?: Timestamp | undefined;

  /**
   * @generated from field: bool is_me = 7;
   */
  isMe: boolean;
};

/**
 * Describes the message protos.vision.membership.v1.VisionMemberView.
 * Use `create(VisionMemberViewSchema)` to create a new message.
 */
export const VisionMemberViewSchema: GenMessage<VisionMemberView> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_vision_membership, 2);

/**
 * @generated from enum protos.vision.membership.v1.VisionMemberRole
 */
export enum VisionMemberRole {
  /**
   * @generated from enum value: VISION_MEMBER_ROLE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: VISION_MEMBER_ROLE_VIEW_ONLY = 1;
   */
  VIEW_ONLY = 1,

  /**
   * @generated from enum value: VISION_MEMBER_ROLE_EDIT = 2;
   */
  EDIT = 2,

  /**
   * @generated from enum value: VISION_MEMBER_ROLE_FULL_ACCESS = 3;
   */
  FULL_ACCESS = 3,
}

/**
 * Describes the enum protos.vision.membership.v1.VisionMemberRole.
 */
export const VisionMemberRoleSchema: GenEnum<VisionMemberRole> = /*@__PURE__*/
  enumDesc(file_vision_membership_v1_vision_membership, 0);

/**
 * @generated from enum protos.vision.membership.v1.VisionInviteStatus
 */
export enum VisionInviteStatus {
  /**
   * @generated from enum value: VISION_INVITE_STATUS_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: VISION_INVITE_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: VISION_INVITE_STATUS_SENDING = 5;
   */
  SENDING = 5,
}

/**
 * Describes the enum protos.vision.membership.v1.VisionInviteStatus.
 */
export const VisionInviteStatusSchema: GenEnum<VisionInviteStatus> = /*@__PURE__*/
  enumDesc(file_vision_membership_v1_vision_membership, 1);

